import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface RenameDialogData {
  title: string;
  currentName: string;
  placeholder?: string;
}

@Component({
  selector: 'app-rename-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './rename-dialog.html',
  styleUrl: './rename-dialog.scss'
})
export class RenameDialog {
  readonly dialogRef = inject(MatDialogRef<RenameDialog>);
  readonly data = inject<RenameDialogData>(MAT_DIALOG_DATA);
  newName: string = '';

  ngOnInit(): void {
    this.newName = this.data.currentName;
  }

  rename() {
    this.dialogRef.close(this.newName.trim());
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
